import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

// DRACO decompression pipeline for compressed globe / model geometry.
// Any .glb exported with Draco geometry compression is decoded through this loader,
// keeping large terrain meshes lightweight over the wire (WebXR bandwidth friendly).
let _draco = null;
export function getDracoLoader() {
  if (_draco) return _draco;
  _draco = new DRACOLoader();
  _draco.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.7/");
  _draco.setDecoderConfig({ type: "js" });
  return _draco;
}

let _gltf = null;
export function getGltfLoader() {
  if (_gltf) return _gltf;
  _gltf = new GLTFLoader();
  _gltf.setDRACOLoader(getDracoLoader());
  return _gltf;
}
